/*
 * Extracted from sections/footer.liquid's inline <script> (footer link-section accordion) - a
 * static IIFE with no dynamic Liquid values, ported to a standalone asset so it's HTTP-cacheable
 * across navigations and removed from the inline HTML parse cost, matching the pattern already
 * used for assets/header-nav.js.
 *
 * Keeps all footer link sections open on desktop and collapsed-to-first on mobile, re-evaluating
 * on viewport resize across the 750px breakpoint.
 */
(function () {
  var section = document.querySelector('.footer-desktop');
  if (!section) return;
  var linkSections = section.querySelectorAll('.footer-desktop__link-section');
  if (!linkSections.length) return;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setDesktopOpen() {
    linkSections.forEach(function (d) {
      d.setAttribute('open', '');
    });
  }

  function setMobileDefault() {
    linkSections.forEach(function (d, i) {
      if (i === 0) {
        d.setAttribute('open', '');
      } else {
        d.removeAttribute('open');
      }
    });
  }

  function closeMobileSections() {
    linkSections.forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  function init() {
    if (isMobile()) {
      setMobileDefault();
    } else {
      setDesktopOpen();
    }
  }

  var mobileView = isMobile();
  init();
  window.addEventListener('resize', function () {
    if (mobileView === isMobile()) return;

    mobileView = isMobile();
    if (isMobile()) {
      closeMobileSections();
    } else {
      setDesktopOpen();
    }
  });

  linkSections.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!isMobile()) {
        setDesktopOpen();
        return;
      }
      if (details.open) {
        linkSections.forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      }
    });
  });
})();
